import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
} from "@material-ui/core";
import Axios from "axios";
import React, {
	forwardRef,
	useCallback,
	useEffect,
	useImperativeHandle,
	useState,
} from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import BuscaClienteModal from "../Orcamentos/Botoes/BuscaClienteModal";
import formFieldsInitial from "./forms/AceiteDadosClienteCampos";

const AceiteDadosCliente = forwardRef((props, ref) => {
	const dadosEmBranco = {
		id: "",
		bairro: "",
		bairro_entrega: "",
		cep: "",
		cep_entrega: "",
		cnpj: "",
		complemento: "",
		complemento_entrega: "",
		contribuinte_estadual: 0,
		cpf: "",
		ddd: "",
		documento: "",
		email: "",
		endereco: "",
		endereco_entrega: "",
		estado: "",
		estado_entrega: "",
		genero: "",
		inscricao_estadual: "",
		inscricao_municipal: "",
		municipio: "",
		municipio_entrega: "",
		nome: "",
		origem: "",
		pais_id: "",
		rg: "",
		telefone: "",
		telefone_sem_ddd: "",
		tipo_consumidor: "",
	};

	const [formData, setFormData] = useState({
		tipo_consumidor: "F",
		contribuinte_estadual: 0,
	});

	// console.log("formData cliente", formData);
	const [formFields, setFormFields] = useState(formFieldsInitial);
	const [formularioAjustado, setFormularioAjustado] = useState(false);
	const [precisaAtualizarClienteNoTotvs, setPrecisaAtualizarClienteNoTotvs] =
		useState(false);

	const ajustFormData = useCallback(() => {
		if (!formularioAjustado) {
			setFormularioAjustado(true);
			let data = props.data.cliente ? props.data.cliente : props.cliente;
			if (Object.keys(data).length === 0) {
				data = {
					tipo_consumidor: "F",
					genero: "F",
					contribuinte_estadual: "2",
					nome: props.data.pessoa.name,
					email:
						props.data.pessoa.email.length > 0
							? props.data.pessoa.email[0].value
							: "",
					documento:
						props.data.pessoa["373927396ff79d7c65eac069c5b10f60f0764530"],
					cep: props.data.pessoa.postal_address_postal_code,
					endereco:
						props.data.pessoa.postal_address_route +
						", " +
						props.data.pessoa.postal_address_street_number,
					bairro: props.data.pessoa.postal_address_sublocality,
					municipio: props.data.pessoa.postal_address_admin_area_level_2,
				};
			}
			setFormData(data);
		}
	});

	useEffect(() => {
		ajustFormData();
	});

	useImperativeHandle(ref, () => ({
		advanceHandler() {
			return SalvaDadosCliente();
		},
	}));
	const inputHandler = (field, value) => {
		// console.log("inputHandler:", field, value);

		setPrecisaAtualizarClienteNoTotvs(true);
		let dados = { ...formData, [field]: value };

		if (field[0] === "tipo_consumidor") {
			dadosEmBranco.tipo_consumidor = value;
			dados = { ...dadosEmBranco, [field]: value };
		}

		if (field[0] === "cTipo") {
			if (value !== "X") {
				dados = {
					...dados,
					cCodigoPais: "01058",
				};
			} else if (value === "X" && formData.cCodigoPais === "01058") {
				dados = {
					...dados,
					cCodigoPais: "",
				};
			}
		}

		if (field[0] === "cCodigoPais") {
			if (formData.cTipo === "X" && value === "01058") {
				toast.error("Pedidos de exportação não podem ser para o Brasil.");
				dados = {
					...dados,
					cCodigoPais: "",
				};
			}
		}

		setFormData(dados);
		if (field[0] === "cep_entrega" || field[0] === "cep") {
			if (value.length === 8 && value.indexOf("-") === -1) {
				buscarDadosCep(value, field);
			} else if (value.length === 9) {
				buscarDadosCep(value, field);
			}
		}
	};

	const buscarDadosCep = (cep, field) => {
		if (formData.tipo_consumidor === "X") return;
		const url = "https://viacep.com.br/ws/" + cep + "/json/";
		Axios.get(url, formData)
			.then(function (response) {
				console.log("field[0]", field[0]);
				if (response.status === 200) {
					if (field[0] === "cep") {
						if (response.data.cep) {
							console.log(response.data);
							setFormData({
								...formData,
								cep: response.data.cep,
								bairro: response.data.bairro,
								municipio: response.data.localidade,
								endereco: response.data.logradouro,
								estado: response.data.uf,
							});
						} else {
							toast.info(
								"Não foi possível encontrar os dados deste CEP, por favor preencha manualmente"
							);
							setFormData({
								...formData,
								cep: cep,
							});
						}
					} else if (field[0] === "cep_entrega") {
						if (response.data.cep) {
							setFormData({
								...formData,
								cep_entrega: response.data.cep,
								bairro_entrega: response.data.bairro,
								municipio_entrega: response.data.localidade,
								endereco_entrega: response.data.logradouro,
								estado_entrega: response.data.uf,
							});
						} else {
							toast.info(
								"Não foi possível encontrar os dados deste CEP, por favor preencha manualmente"
							);
							setFormData({
								...formData,
								cep: cep,
							});
						}
					}
				} else {
					toast.error("CEP não encontrado.");
				}
			})
			.catch(function (error) {
				toast.error("Erro:" + error);
			});
	};

	const SalvaDadosCliente = () => {
		console.log("SalvaDadosCliente-------------------");

		props.setLoading(true);

		// Validação
		let fieldsNew = [];
		let erros = false;
		formFields.map((field, i) => {
			if (
				field.required &&
				!formData[field.id] &&
				mostrarInput(field.mostrarEmTipo)
			) {
				erros = true;
				fieldsNew.push({
					...field,
					error: true,
				});
			} else {
				fieldsNew.push({
					...field,
					error: false,
				});
			}
		});
		setFormFields(fieldsNew);
		if (erros) {
			toast.error("Preencha todos os campos em vermelho");
			props.setLoading(false);
			return false;
		}
		// Validação - fim

		let dados = formData;
		console.log(dados);
		if (dados.tipo_consumidor === "X") {
			dados = {
				...dados,
				estado: "EX",
				estado_entrega: "EX",
				rg: dados.documento,
				resource: 1,
			};
		} else {
			dados = {
				...dados,
				resource: 1,
			};

			if (!dados.pais_id || dados.pais_id === "") {
				dados = {
					...dados,
					pais_id: "01058",
				};
			}
		}

		if (precisaAtualizarClienteNoTotvs) {
			Axios.post(
				config.get("url_api") +
					"totvs/cliente/atualizarV2" +
					"?token=" +
					config.get("token"),
				dados
			)
				.then(function (response) {
					if (response.status === 200) {
						if (!response.data.sucesso) {
							console.log("response.data erro", response.data);

							if (response.data.mensagem) toast.error(response.data.mensagem);
							else toast.error("Erro ao salvar os dados do cliente.");
							props.setLoading(false);
							return true;
						} else {
							console.log("response.data ok", response.data);
							props.setCliente(response.data.cliente);
							props.setLoading(false);
							props.forceNext();
							return true;
						}
					} else {
						toast.error("Erro ao enviar dados.");
						props.setLoading(false);
						return true;
					}
				})
				.catch(function (error) {
					console.log("error", error);
					toast.error("Erro ao salvar os dados do cliente.");
					props.setLoading(false);
				});
		} else {
			// console.log("Não Alterar");
			props.setCliente(formData);
			props.setLoading(false);
			return true;
		}
	};

	const copiarEnderecoCliente = () => {
		setFormData({
			...formData,
			cep_entrega: formData["cep"],
			endereco_entrega: formData["endereco"],
			complemento_entrega: formData["complemento"],
			bairro_entrega: formData["bairro"],
			estado_entrega: formData["estado"],
			municipio_entrega: formData["municipio"],
		});
	};

	const mostrarInput = (tipos) => {
		return tipos.indexOf(formData.tipo_consumidor) !== -1;
	};

	const alteraDadosForm = (dados) => {
		setPrecisaAtualizarClienteNoTotvs(false);
		setFormData(dados);
	};

	return (
		<React.Fragment>
			<BuscaClienteModal setFormData={alteraDadosForm} />
			{props.data.success && (
				<Paper className="p-1">
					<Grid container spacing={1}>
						{formFields.map((field) => {
							return (
								<React.Fragment key={field.id}>
									{field.id === "cep" && (
										<Grid item md={12}>
											<h3>Endereço do cliente</h3>
										</Grid>
									)}
									{field.id === "cep_entrega" && (
										<Grid item md={12}>
											<h3>
												Endereço de entrega
												<small
													onClick={() => copiarEnderecoCliente()}
													className="btn btn-xs"
												>
													copiar endereço do cliente
												</small>
											</h3>
										</Grid>
									)}

									{field.type === "select" &&
										mostrarInput(field.mostrarEmTipo) && (
											<Grid item md={field.size}>
												<FormControl fullWidth className="select-form">
													<InputLabel error={field.error}>
														{field.label}
													</InputLabel>
													<Select
														error={field.error}
														id={field.id}
														fullWidth
														required={field.required}
														value={
															formData && formData[field.id]
																? formData[field.id]
																: ""
														}
														onChange={(e) =>
															inputHandler([field.id], e.target.value)
														}
													>
														{field.options.map((item) => (
															<MenuItem key={item.value} value={item.value}>
																{item.label}
															</MenuItem>
														))}
													</Select>
												</FormControl>
											</Grid>
										)}

									{field.type === "select_vf" &&
										mostrarInput(field.mostrarEmTipo) && (
											<Grid item md={field.size}>
												<FormControl fullWidth className="select-form">
													<InputLabel error={field.error}>
														{field.label}
													</InputLabel>
													<Select
														error={field.error}
														id={field.id}
														fullWidth
														required={field.required}
														value={
															formData && formData[field.id]
																? formData[field.id]
																: 0
														}
														onChange={(e) =>
															inputHandler([field.id], e.target.value)
														}
													>
														{field.options.map((item) => (
															<MenuItem key={item.value} value={item.value}>
																{item.label}
															</MenuItem>
														))}
													</Select>
												</FormControl>
											</Grid>
										)}

									{field.type === "listaPaises" &&
										formData &&
										mostrarInput(field.mostrarEmTipo) &&
										props.data.paises && (
											<Grid item md={field.size}>
												<FormControl fullWidth className="select-form">
													<InputLabel>{field.label}</InputLabel>
													<Select
														id={field.id}
														fullWidth
														required={field.required}
														value={
															formData && formData[field.id]
																? formData[field.id]
																: ""
														}
														onChange={(e) =>
															inputHandler([field.id], e.target.value)
														}
													>
														{Object.keys(props.data.paises).map((key) => (
															<MenuItem key={key} value={key}>
																{props.data.paises[key]}
															</MenuItem>
														))}
													</Select>
												</FormControl>
											</Grid>
										)}
									{field.type === "numeros" && (
										<Grid item md={field.size}>
											<TextField
												id={field.id}
												label={field.label}
												error={field.error}
												type={field.type}
												margin="dense"
												autoComplete="off"
												fullWidth
												required={field.required}
												value={
													formData && formData[field.id]
														? formData[field.id]
														: ""
												}
												onChange={(e) => {
													const regex = /\D/gi;
													return inputHandler(
														[field.id],
														e.target.value.replaceAll(regex, "")
													);
												}}
												inputProps={{
													maxLength: field.maxLength,
												}}
											/>
										</Grid>
									)}
									{field.type === "text" && mostrarInput(field.mostrarEmTipo) && (
										<Grid item md={field.size}>
											<TextField
												id={field.id}
												label={field.label}
												error={field.error}
												type={field.type}
												margin="dense"
												autoComplete="off"
												fullWidth
												required={field.required}
												value={
													formData && formData[field.id]
														? formData[field.id]
														: ""
												}
												onChange={(e) =>
													inputHandler([field.id], e.target.value)
												}
												inputProps={{
													maxLength: field.maxLength,
												}}
											/>
										</Grid>
									)}
								</React.Fragment>
							);
						})}
					</Grid>
				</Paper>
			)}
		</React.Fragment>
	);
});

export default AceiteDadosCliente;
